import { type Epic, combineEpics } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { acceptInviteRequest } from '@/api/members';
import { navigate } from '@/slices/app';
import i18n from '@/i18n';
import { acceptInvite } from '../actions';

const acceptInviteEpic: Epic = (action$) =>
  action$.pipe(
    filter(acceptInvite.match),
    request(({ payload }) => acceptInviteRequest(payload), acceptInvite),
  );

const acceptInviteSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(acceptInvite.succeeded.match),
    mergeMap(() => [
      openSnackbar({
        snackbarType: 'success',
        snackbarMessage: i18n.t('ACCEPT_INVITE_SUCCESS'),
      }),
      navigate({ to: '/' }),
    ]),
  );

export default combineEpics(acceptInviteEpic, acceptInviteSucceededEpic);
